import { render, staticRenderFns } from "./ListadoEventos.vue?vue&type=template&id=ce35ccee&scoped=true"
import script from "./ListadoEventos.vue?vue&type=script&setup=true&lang=js"
export * from "./ListadoEventos.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ListadoEventos.vue?vue&type=style&index=0&id=ce35ccee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce35ccee",
  null
  
)

export default component.exports